<template>
  <div>
    <section class="content">

      <div class="row" v-if="canAccess('Setting-view')">
        <div class="col-md-3">
          <div class="row">
            <div class="col-md-12">

              <div class="box">
                <div class="box-header with-border label-primary">
                  <h3 class="box-title">Logo</h3>
                  
                  <br>
                  <!-- <button v-if="canAccess('Setting-update')" type="button" class="btn btn-primary" @click="dailyCronButton('2023-07-01')"></button> -->
                  
                </div>
                <div class="box-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="card card-primary card-outline">
                          <form @submit.prevent="updatelogo">
                            <div class="card-body box-profile">
                              <div class="text-center">
                                <img
                                  class="profile-user-img img-fluid img-circle"
                                  :src="logo"
                                  alt="User profile picture"
                                />
                              </div>
                              <!-- <a v-for="(url, index) in urls" :key="index" :href="`${url}/manualcron/daily`" class="btn btn-box-tool"> {{url}}</a> -->
                              <h3 class="profile-username text-center">{{getRecord.shortName}}</h3>

                              <p class="text-muted text-center">
                                {{getRecord.companyName}}
                              </p>
                              <input v-if="canAccess('Setting-logo')" type="file" accept="image/*" @change="uploadImage($event)" id="file-input">
                             
                              
                            </div>
                          </form>
                          <!-- /.card-body -->
                          <!-- <br>Last Daily Crone Date: {{ getRecord.lastDailyCronDate}}
                          <br>Last Interest Crone Date: {{ getRecord.lastInterestOnlyCronDate }}
                          <br>Current Date: {{ currentDate() }} -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="col-md-12">

              <div class="box">
                <div class="box-header with-border label-primary">
                  <h3 class="box-title">Favicon</h3>
                  
                </div>
                <div class="box-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="card card-primary card-outline">
                          <div class="card-body box-profile">
                            <div class="text-center">
                              <img
                                  class="profile-user-img img-fluid img-circle"
                                  :src="favicon"
                                  alt="User profile picture"
                                />
                              <input v-if="canAccess('Setting-favicon')" type="file" accept="image/*" @change="uploadFavicon($event)" id="file-input">
                            </div>

                          </div>
                          <!-- /.card-body -->
                        </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>          
          </div>
        </div>
        <div class="col-md-9">

          <!-- Default box -->
                <div class="box">
                  <div class="box-header with-border label-info">
                    <h3 class="box-title">Company Profile Edit</h3>
                    <span class="float-right">
                      <button v-if="canAccess('Setting-update')" type="button" class="btn btn-primary" @click="editProfile"> <i class="fa fa-pencil"></i></button>
                    </span>

                  </div>
                  <div class="box-body">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="card">
                          
                          <!-- /.card-header -->
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-6">
                                <table class="table table-sm table-bordered table-stripped table-hover">
                                  <thead>
                                    <tr>
                                      <th>Website</th>
                                      <td>{{getRecord.website}}</td>
                                    </tr>
                                    <tr>
                                      <th>Software URL</th>
                                      <td>{{getRecord.url}}</td>
                                    </tr>
                                    <tr>
                                      <th>Company Name</th>
                                      <td>{{getRecord.companyName}}</td>
                                    </tr>
                                    <tr>
                                      <th>Short Name</th>
                                      <td>{{getRecord.shortName}}</td>
                                    </tr>
                                    <tr>
                                      <th>UPI ID</th>
                                      <td>{{getRecord.upiId}}</td>
                                    </tr>
                                    <tr>
                                      <th>CIBIL Member Code</th>
                                      <td>{{getRecord.cibilMemberCode}}</td>
                                    </tr>
                                    <tr>
                                      <th>CIBIL Member Short Name</th>
                                      <td>{{getRecord.cibilMemberShortName}}</td>
                                    </tr>
                                    <tr>
                                      <th>About</th>
                                      <td>
                                        {{getRecord.about}}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>CIN</th>
                                      <td>{{getRecord.cin}}</td>
                                    </tr>
                                    <tr>
                                      <th>PAN</th>
                                      <td>{{getRecord.pan}}</td>
                                    </tr>
                                    <tr>
                                      <th>TAN</th>
                                      <td>{{getRecord.tan}}</td>
                                    </tr>
                                    <tr>
                                      <th>GST No</th>
                                      <td>{{getRecord.gstin}}</td>
                                    </tr>
                                    <tr>
                                      <th>Category</th>
                                      <td>{{getRecord.companyCategory}}</td>
                                    </tr>
                                    <tr>
                                      <th>Class</th>
                                      <td>{{getRecord.companyClass}}</td>
                                    </tr>
                                    <tr>
                                      <th>Authorized Capital</th>
                                      <td>{{getRecord.authrizedCapital}}</td>
                                    </tr>
                                    <tr>
                                      <th>Paid Up Capital</th>
                                      <td>{{getRecord.paid_upCapital}}</td>
                                    </tr>
                                    <tr>
                                      <th>Share Nominal Value</th>
                                      <td>{{getRecord.shareNominalValue}}</td>
                                    </tr>
                                    <tr>
                                      <th>State of Registration</th>
                                      <td>{{getRecord.stateOfRegistration}}</td>
                                    </tr>
                                    <tr>
                                      <th>Incorporation Country</th>
                                      <td>{{getRecord.country}}</td>
                                    </tr>
                                    <tr>
                                      <th>Incorporation Date</th>
                                      <td>{{getRecord.incorporationDate}}</td>
                                    </tr>
                                    
                                    <tr>
                                      <th>Email</th>
                                      <td>{{getRecord.email}}</td>
                                    </tr>
                                    <tr>
                                      <th>Contact Number 1</th>
                                      <td>{{getRecord.mobile}}</td>
                                    </tr>
                                    <tr>
                                      <th>Contact Number 2</th>
                                      <td>{{getRecord.phone}}</td>
                                    </tr>
                                    <tr>
                                      <th>Landline No</th>
                                      <td>{{getRecord.landline}}</td>
                                    </tr>
                                    <tr>
                                      <th>Address</th>
                                      <td>
                                        {{getRecord.address}}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>City</th>
                                      <td>
                                        {{getRecord.city}}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>Pincode</th>
                                      <td>{{getRecord.pin}}</td>
                                    </tr>
                                    <tr>
                                      <th>State</th>
                                      <td>{{getRecord.state}}</td>
                                    </tr>
                                  </thead>
                                </table>
                              </div>
                              <div class="col-md-6">
                                <table class="table table-sm table-bordered table-stripped table-hover">
                                  <thead>
                                    <tr>
                                      <th>Session</th>
                                      <td><span v-if="getRecord.financial_session">{{getRecord.financial_session.session}}</span></td>
                                    </tr>
                                    <tr>
                                      <th>Software Version</th>
                                      <td>{{getRecord.settings_version}}</td>
                                    </tr>
                                    <tr>
                                      <th>Software Versioning Date</th>
                                      <td>{{getRecord.settings_system_javascript_versioning}}</td>
                                    </tr>
                                    <tr>
                                      <th>Last Daily Cron Date</th>
                                      <td>{{getRecord.lastDailyCronDate}}</td>
                                    </tr>
                                    <tr>
                                      <th>Last Daily Interest Cron Date</th>
                                      <td>{{getRecord.lastInterestOnlyCronDate}}</td>
                                    </tr>
                                    <tr>
                                      <th>Customer KYC Status</th>
                                      <td>{{getRecord.enableMandatoryCustomerKyc}}</td>
                                    </tr>
                                    <tr>
                                      <th>Send SMS On Customer Registration</th>
                                      <td>{{getRecord.createCustomerSMS}}</td>
                                    </tr>
                                    <tr>
                                      <th>Send SMS On Password Reset</th>
                                      <td>{{getRecord.passwordResetSMS}}</td>
                                    </tr>
                                    <tr>
                                      <th>Due Remainder SMS</th>
                                      <td>{{getRecord.croneDueReminderSMS}}</td>
                                    </tr>
                                    <tr>
                                      <th>Member Verify OTP SMS</th>
                                      <td>{{getRecord.memberVerifyOTPSMS}}</td>
                                    </tr>
                                    <tr>
                                      <th>Staff Verify OTP SMS</th>
                                      <td>{{getRecord.staffVerifyOTPSMS}}</td>
                                    </tr>
                                    <tr>
                                      <th>No of EMI Remainder SMS Days</th>
                                      <td>{{getRecord.emiReminderSendSMSDayBefore}}</td>
                                    </tr>
                                    <tr>
                                      <th>Send SMS Customer Loan Disbursement </th>
                                      <td>{{getRecord.loanDisbursementSMS}}</td>
                                    </tr>
                                    <tr>
                                      <th>Send SMS On EMI Collection</th>
                                      <td>{{getRecord.emiCollectionSMS}}</td>
                                    </tr>
                                    <tr>
                                      <th>Document Verification SMS</th>
                                      <td>{{getRecord.documentVerificationSMS}}</td>
                                    </tr>
                                    <tr>
                                      <th>Customer Credentials SMS</th>
                                      <td>{{getRecord.customerCredentionSMS}}</td>
                                    </tr>
                                    <tr>
                                      <th>Guarantor Verify OTP SMS</th>
                                      <td>{{getRecord.guarantorVerifyOTPSMS}}</td>
                                    </tr>
                                    <tr>
                                      <th>Staff Verify SMS </th>
                                      <td>{{getRecord.staffCredentionSMS}}</td>
                                    </tr>
                                    <tr>
                                      <th>currency Symbol</th>
                                      <td>{{getRecord.currencySymbol}}</td>
                                    </tr><tr>
                                      <th>Decimal Places</th>
                                      <td>{{getRecord.decimalPlaces}}</td>
                                    </tr><tr>
                                      <th>Decimal Places For Amt In Words</th>
                                      <td>{{getRecord.decimalPlacesForAmtInWords}}</td>
                                    </tr><tr>
                                      <th>Financial Year Begin From</th>
                                      <td>{{getRecord.financialYearBeginFrom}}</td>
                                    </tr><tr>
                                      <th>Formal Name</th>
                                      <td>{{getRecord.formalName}}</td>
                                    </tr><tr>
                                      <th>Word Representing Amt After Decimal</th>
                                      <td>{{getRecord.wordRepresentingAmtAfterDecimal}}</td>
                                    </tr><tr>
                                      <th>Auto Approve Member Collection Status</th>
                                      <td>{{getRecord.autoApproveMemberCollection}}</td>
                                    </tr><tr>
                                      <th>Show All Members</th>
                                      <td>{{getRecord.showAllMembers}}</td>
                                    </tr>
                                  </thead>
                                  <tbody></tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          <!-- /.card-body -->
                        </div>
                      </div>
                      <!-- /.col -->
                    </div>
                    <!-- /.row -->

                  </div>
                  <!-- /.box-body -->
                  <div class="box-footer">
                    Company Profile
                  </div>
                  <!-- /.box-footer-->
                </div>
                <!-- /.box -->


        </div>        
      </div>
      

    </section>

        <div class="modal fade" id="modal-xl">
          <div class="modal-dialog">
            <div class="modal-content">
              <form @submit.prevent="updateProfile()">
                <div class="modal-header bg-aqua">
                  
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">Update Company Profile</h4>
                </div>
                
                <div class="modal-body">
                  <!-- right column -->          
                    <div class="card card-warning">
                      <!-- /.card-header -->
                      
                      <div class="card-body">
                        
                          <div class="row">
                            <div class="col-sm-6">
                              <!-- text input -->
                              <div class="form-group">
                                <label
                                  >Name <span class="red">*</span></label
                                >
                                <input
                                v-model="form.name"
                                type="text"
                                name="name"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('name'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="name"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Company Name <span class="red">*</span></label
                                >
                                <input
                                v-model="form.companyName"
                                type="text"
                                name="companyName"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('companyName'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="companyName"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Short Name <span class="red">*</span></label
                                >
                                <input
                                v-model="form.shortName"
                                type="text"
                                name="shortName"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('shortName'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="shortName"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >UPI ID <span class="red">*</span></label
                                >
                                <input
                                v-model="form.upiId"
                                type="text"
                                name="upiId"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('upiId'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="upiId"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >CIBIL Member Code <span class="red">*</span></label
                                >
                                <input
                                v-model="form.cibilMemberCode"
                                type="text"
                                name="cibilMemberCode"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('cibilMemberCode'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="cibilMemberCode"
                              ></has-error>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label
                                  >CIBIL Member Short Name <span class="red">*</span></label
                                >
                                <input
                                v-model="form.cibilMemberShortName"
                                type="text"
                                name="cibilMemberShortName"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('cibilMemberShortName'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="cibilMemberShortName"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Website <span class="red">*</span></label
                                >
                                <input
                                v-model="form.website"
                                type="text"
                                name="website"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('website'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="website"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >About Company <span class="red">*</span></label
                                >
                                <textarea
                                v-model="form.about"
                                name="about"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('about'),
                                }"
                                >
                                </textarea>
                              <has-error
                                :form="form"
                                field="about"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  > Customer KYC Mandatory
                                  <span class="red">*</span></label
                                >
                                <select
                                v-model="form.enableMandatoryCustomerKyc"
                                name="enableMandatoryCustomerKyc"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('enableMandatoryCustomerKyc'),
                                }"
                              >
                                <option v-if="!form.enableMandatoryCustomerKyc" selected value="">
                                  Select KYC Mandatory Status
                                </option>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                              </select>
                              <has-error
                                :form="form"
                                field="enableMandatoryCustomerKyc"
                              ></has-error>
                              </div>
                              
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <h2>Reg. Office Address :</h2>
                            </div>

                            <div class="col-sm-6">
                              <div class="form-group">
                                <label for="Session">Session</label>
                                <v-select v-model="session" name="financial_year_id" label="name" :options="sessions" placeholder="Select Session" v-on:input="selectSession"></v-select>
                                
                                <has-error
                                  :form="form"
                                  field="financial_year_id"
                                ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >URL <span class="red">*</span></label
                                >
                                <input
                                v-model="form.url"
                                type="text"
                                name="url"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('url'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="url"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Contact Number 1
                                  <span class="red">*</span></label
                                >
                                <input
                                v-model="form.mobile"
                                type="text"
                                name="mobile"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('mobile'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="mobile"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Contact Number 2
                                  <span class="red">*</span></label
                                >
                                <input
                                v-model="form.phone"
                                type="text"
                                name="phone"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('phone'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="phone"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label>Landline Number</label>
                                <input
                                v-model="form.landline"
                                type="text"
                                name="landline"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('landline'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="landline"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label>Address<span class="red"></span></label>
                                <input
                                v-model="form.address"
                                type="text"
                                name="address"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('address'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="address"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label>City <span class="red">*</span></label>
                                <input
                                v-model="form.city"
                                type="text"
                                name="city"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('city'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="city"
                              ></has-error>
                              </div>
                              
                              <div class="form-group">
                                <label>Pincode <span class="red">*</span></label>
                                <input
                                v-model="form.pin"
                                type="text"
                                name="pin"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('pin'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="pin"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Select State <span class="red">*</span></label
                                >
                                <select
                                v-model="form.state"
                                name="state"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('state'),
                                }"
                              >
                                <option v-if="!form.state" selected value="">
                                  Select State
                                </option>
                                <option
                                  :value="stat.name"
                                  v-for="stat in states"
                                  :key="stat.id"
                                >
                                  {{ stat.name }}
                                </option>
                              </select>
                              <has-error
                                :form="form"
                                field="state"
                              ></has-error>
                              </div>
                              
                              <div class="form-group">
                                <label
                                  >Contact Email <span class="red">*</span></label
                                >
                                <input
                                v-model="form.email"
                                type="email"
                                name="email"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('email'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="email"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label>FAX Number</label>
                                <input
                                v-model="form.fax"
                                type="text"
                                name="fax"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('fax'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="fax"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label>PAN Number</label>
                                <input
                                v-model="form.pan"
                                type="text"
                                name="pan"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('pan'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="pan"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label>Formal Name</label>
                                <input v-model="form.formalName" type="text" name="formalName" class="form-control" :class="{ 'is-invalid': form.errors.has('formalName'), }" />
                                <has-error :form="form" field="formalName" ></has-error>
                              </div>
                              <div class="form-group">
                                <label>GST Number</label>
                                <input
                                v-model="form.gstin"
                                type="text"
                                name="gstin"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('gstin'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="gstin"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Company Class <span class="red">*</span></label
                                >
                                <input
                                v-model="form.companyClass"
                                type="text"
                                name="companyClass"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('companyClass'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="companyClass"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  > Auto Approve Member Collection
                                  <span class="red">*</span></label
                                >
                                <select
                                  v-model="form.autoApproveMemberCollection"
                                  name="autoApproveMemberCollection"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('autoApproveMemberCollection'),
                                  }"
                                >
                                  <option v-if="!form.autoApproveMemberCollection" selected value="">
                                    Select Auto Approve Member Collection Status
                                  </option>
                                  <option value="true">Active</option>
                                  <option value="false">Inactive</option>
                                </select>
                                <has-error
                                  :form="form"
                                  field="autoApproveMemberCollection"
                                ></has-error>
                              </div>
                            </div>

                            <div class="col-sm-6">
                              
                              <div class="form-group">
                                <label
                                  > State of Registration
                                  <span class="red">*</span></label
                                >
                                <select
                                v-model="form.stateOfRegistration"
                                name="stateOfRegistration"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('stateOfRegistration'),
                                }"
                              >
                                <option v-if="!form.stateOfRegistration" selected value="">
                                  Select State of Registration
                                </option>
                                <option
                                  :value="stat.name"
                                  v-for="stat in states"
                                  :key="stat.id"
                                >
                                  {{ stat.name }}
                                </option>
                              </select>
                              <has-error
                                :form="form"
                                field="stateOfRegistration"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Authorized Capital
                                  <span class="red">*</span></label
                                >
                                <input
                                v-model="form.authrizedCapital"
                                type="text"
                                name="authrizedCapital"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('authrizedCapital'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="authrizedCapital"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >CIN Number <span class="red">*</span></label
                                >
                                <input
                                v-model="form.cin"
                                type="text"
                                name="cin"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('cin'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="cin"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label>TAN Number</label>
                                <input
                                v-model="form.tan"
                                type="text"
                                name="tan"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('tan'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="tan"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Company Category
                                  <span class="red">*</span></label
                                >
                                <input
                                v-model="form.companyCategory"
                                type="text"
                                name="companyCategory"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('companyCategory'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="companyCategory"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Incorporation Date
                                  <span class="red">*</span></label
                                >
                                <input
                                v-model="form.incorporationDate"
                                type="date"
                                name="incorporationDate"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('incorporationDate'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="incorporationDate"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Incorporation Country
                                  <span class="red">*</span></label
                                >
                                <input
                                v-model="form.country"
                                type="text"
                                name="country"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('country'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="country"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  >Paid Up Capital
                                  <span class="red">*</span></label
                                >
                                <input
                                v-model="form.paid_upCapital"
                                type="text"
                                name="paid_upCapital"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('paid_upCapital'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="paid_upCapital"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label>Share Nominal Value</label>
                                <input
                                v-model="form.shareNominalValue"
                                type="text"
                                name="shareNominalValue"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('shareNominalValue'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="shareNominalValue"
                              ></has-error>
                              </div>
                              <div class="form-group">
                                <label>Financial Year Begin From</label>
                                <input
                                v-model="form.financialYearBeginFrom"
                                type="date"
                                name="financialYearBeginFrom"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('financialYearBeginFrom'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="financialYearBeginFrom"
                              ></has-error>
                              </div>

                              <div class="form-group">
                                <label>Currency Symbol</label>
                                <input v-model="form.currencySymbol" type="text" name="currencySymbol" class="form-control" :class="{ 'is-invalid': form.errors.has('currencySymbol'), }" />
                                <has-error :form="form" field="currencySymbol" ></has-error>
                              </div>
                              <div class="form-group">
                                <label>Decimal Places</label>
                                <input v-model="form.decimalPlaces" type="text" name="decimalPlaces" class="form-control" :class="{ 'is-invalid': form.errors.has('decimalPlaces'), }" />
                                <has-error :form="form" field="decimalPlaces" ></has-error>
                              </div>
                              <div class="form-group">
                                <label>Decimal Places For Amt In Words</label>
                                <input v-model="form.decimalPlacesForAmtInWords" type="text" name="decimalPlacesForAmtInWords" class="form-control" :class="{ 'is-invalid': form.errors.has('decimalPlacesForAmtInWords'), }" />
                                <has-error :form="form" field="decimalPlacesForAmtInWords" ></has-error>
                              </div>
                              <div class="form-group">
                                <label>Word Representing Amt After Decimal</label>
                                <input v-model="form.wordRepresentingAmtAfterDecimal" type="text" name="wordRepresentingAmtAfterDecimal" class="form-control" :class="{ 'is-invalid': form.errors.has('wordRepresentingAmtAfterDecimal'), }" />
                                <has-error :form="form" field="wordRepresentingAmtAfterDecimal" ></has-error>
                              </div>
                              <div class="form-group">
                                <label
                                  > Show All Members
                                  <span class="red">*</span></label
                                >
                                <select
                                  v-model="form.showAllMembers"
                                  name="showAllMembers"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has('showAllMembers'),
                                  }"
                                >
                                  <option v-if="!form.showAllMembers" selected value="">
                                    Select Show All Members Status
                                  </option>
                                  <option value="true">Active</option>
                                  <option value="false">Inactive</option>
                                </select>
                                <has-error
                                  :form="form"
                                  field="showAllMembers"
                                ></has-error>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <h2>SMS Settings :</h2>
                            </div>
                            <div class="col-sm-6">
                              <strong><i class="fa fa-hand-o-right text-info"></i> SMS Service </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="enableSMS" class="minimal" value="true"  v-model="form.enableSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="enableSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="enableSMS" class="minimal" value="false"  v-model="form.enableSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="enableSMS"></has-error>
                                </label>
                              </div>

                              <strong><i class="fa fa-hand-o-right text-info"></i> Send SMS Customer Registration </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="createCustomerSMS" class="minimal" value="true"  v-model="form.createCustomerSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="createCustomerSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="createCustomerSMS" class="minimal" value="false"  v-model="form.createCustomerSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="createCustomerSMS"></has-error>
                                </label>
                              </div>

                              <strong><i class="fa fa-hand-o-right text-info"></i> Send SMS On Password Reset </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="passwordResetSMS" class="minimal" value="true"  v-model="form.passwordResetSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="passwordResetSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="passwordResetSMS" class="minimal" value="false"  v-model="form.passwordResetSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="passwordResetSMS"></has-error>
                                </label>
                              </div>

                              <strong><i class="fa fa-hand-o-right text-info"></i> Due Remainder SMS </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="croneDueReminderSMS" class="minimal" value="true"  v-model="form.croneDueReminderSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="croneDueReminderSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="croneDueReminderSMS" class="minimal" value="false"  v-model="form.croneDueReminderSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="croneDueReminderSMS"></has-error>
                                </label>
                              </div>

                              <strong><i class="fa fa-hand-o-right text-info"></i> Member Verify OTP SMS </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="memberVerifyOTPSMS" class="minimal" value="true"  v-model="form.memberVerifyOTPSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="memberVerifyOTPSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="memberVerifyOTPSMS" class="minimal" value="false"  v-model="form.memberVerifyOTPSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="memberVerifyOTPSMS"></has-error>
                                </label>
                              </div>

                              <strong><i class="fa fa-hand-o-right text-info"></i> Staff Verify OTP SMS </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="staffVerifyOTPSMS" class="minimal" value="true"  v-model="form.staffVerifyOTPSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="staffVerifyOTPSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="staffVerifyOTPSMS" class="minimal" value="false"  v-model="form.staffVerifyOTPSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="staffVerifyOTPSMS"></has-error>
                                </label>
                              </div>

                              <div class="form-group">
                                <label
                                  >No of EMI Remainder SMS Days <span class="red">*</span></label
                                >
                                <input
                                v-model="form.emiReminderSendSMSDayBefore"
                                type="text"
                                name="emiReminderSendSMSDayBefore"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('emiReminderSendSMSDayBefore'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="emiReminderSendSMSDayBefore"
                              ></has-error>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <strong><i class="fa fa-hand-o-right text-info"></i> Send SMS Loan Disbursement </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="loanDisbursementSMS" class="minimal" value="true"  v-model="form.loanDisbursementSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="loanDisbursementSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="loanDisbursementSMS" class="minimal" value="false"  v-model="form.loanDisbursementSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="loanDisbursementSMS"></has-error>
                                </label>
                              </div>
                              <strong><i class="fa fa-hand-o-right text-info"></i> Send SMS On EMI Collection </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="emiCollectionSMS" class="minimal" value="true"  v-model="form.emiCollectionSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="emiCollectionSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="emiCollectionSMS" class="minimal" value="false"  v-model="form.emiCollectionSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="emiCollectionSMS"></has-error>
                                </label>
                              </div>
                              <strong><i class="fa fa-hand-o-right text-info"></i> Document Verification SMS </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="documentVerificationSMS" class="minimal" value="true"  v-model="form.documentVerificationSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="documentVerificationSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="documentVerificationSMS" class="minimal" value="false"  v-model="form.documentVerificationSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="documentVerificationSMS"></has-error>
                                </label>
                              </div>
                              <i class="fa fa-hand-o-right text-info"></i> <strong>Customer Credentials SMS </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="customerCredentionSMS" class="minimal" value="true"  v-model="form.customerCredentionSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="customerCredentionSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="customerCredentionSMS" class="minimal" value="false"  v-model="form.customerCredentionSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="customerCredentionSMS"></has-error>
                                </label>
                              </div>
                              <strong><i class="fa fa-hand-o-right text-info"></i> Guarantor Verify OTP SMS </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="guarantorVerifyOTPSMS" class="minimal" value="true"  v-model="form.guarantorVerifyOTPSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="guarantorVerifyOTPSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="guarantorVerifyOTPSMS" class="minimal" value="false"  v-model="form.guarantorVerifyOTPSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="guarantorVerifyOTPSMS"></has-error>
                                </label>
                              </div>
                              <strong><i class="fa fa-hand-o-right text-info"></i> Staff Credential SMS </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="staffCredentionSMS" class="minimal" value="true"  v-model="form.staffCredentionSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="staffCredentionSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="staffCredentionSMS" class="minimal" value="false"  v-model="form.staffCredentionSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="staffCredentionSMS"></has-error>
                                </label>
                              </div>
                              <strong><i class="fa fa-hand-o-right text-info"></i> Settlement SMS </strong>
                              <div class="form-group">
                                <label>
                                  <input type="radio" name="sattlementSMS" class="minimal" value="true"  v-model="form.sattlementSMS">
                                  <i class="fa fa-check text-success"></i> 
                                  <has-error :form="form" field="sattlementSMS"></has-error>
                                </label>
                                <label>
                                  <input type="radio" name="sattlementSMS" class="minimal" value="false"  v-model="form.sattlementSMS">
                                  <i class="fa fa-remove text-danger"></i> 
                                  <has-error :form="form" field="sattlementSMS"></has-error>
                                </label>
                              </div>
                            </div>
                          </div>
                        
                      </div>
                      
                      <!-- /.card-body -->
                    </div>
                  
                  <!--/.col (right) -->
                </div>
                
                <div class="modal-footer text-center">
                  <button type="submit" class="btn btn-success">
                    SAVE PROFILE
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->


  </div>
</template>

<script>
export default {
  name: 'profile',
  data () {
    return {
      // urls: [
      //   'https://demo.microfinancesoftware.in/backend/api',
      //   'http://127.0.0.1:8000/api',
      //   'https://superbond.microfinancesoftware.in/backend/api',
      //   'https://gnl.microfinancesoftware.in/backend/api',
      //   'https://cresco.microfinancesoftware.in/backend/api',
      //   'https://app.surahafinance.com/backend/api',
      //   'https://swapnashikha.microfinancesoftware.in/backend/api',
      //   'https://pushpak.microfinancesoftware.in/backend/api',
      //   'https://surendra.microfinancesoftware.in/backend/api',
      //   'https://smfcash.microfinancesoftware.in/backend/api',
      //   'https://demo.incrediblemicro.com/backend/api',
      //   'https://app.ezeepayfinance.com/backend/api',
      //   'https://foridofinance.com/demo/api',
      //   'https://app.aonemicrofinance.com/backend/api',
      //   'https://mahilasakti.microfinancesoftware.in/backend/api',
      //   'https://bullet.microfinancesoftware.in/backend/api',
      //   'https://microfinance.smegrowthmicrofoundation.com/backend/api',
      //   'https://utkrast.microfinancesoftware.in/backend/api',
      //   'https://siyamicro.microfinancesoftware.in/backend/api',
      //   'https://gagret.microfinancesoftware.in/backend/api',
      //   'https://aglfmfi.microfinancesoftware.in/backend/api',
      //   'https://aglfoundation.microfinancesoftware.in/backend/api',
      //   'https://pava.microfinancesoftware.in/backend/api',
      //   'https://mrp.microfinancesoftware.in/backend/api',
      //   'https://app.janshaktimicrofinance.com/backend/api',
      //   'https://app.dotinfinance.com/backend/api',
      //   'https://rkc.microfinancesoftware.in/backend/api',
      //   'https://shorishahahfinance.microfinancesoftware.in/backend/api',
      //   'https://vidhaan.microfinancesoftware.in/backend/api',
      //   'https://swapnapurti.microfinancesoftware.in/backend/api',
      //   'https://gagret1.microfinancesoftware.in/backend/api',
      //   'https://jansuvidha.microfinancesoftware.in/backend/api',
      //   'https://sanwariya.microfinancesoftware.in/backend/api',
      //   'https://udaanlo.microfinancesoftware.in/backend/api',
      //   'https://fingold.microfinancesoftware.in/backend/api',
      //   'https://rewadi.microfinancesoftware.in/backend/api',
      //   'https://app.eonmicrofinance.com/backend/api',
      //   'https://dazzelloans.microfinancesoftware.in/backend/api',
      //   'https://manisha.microfinancesoftware.in/backend/api',
      //   'https://guddu.microfinancesoftware.in/backend/api',
      //   'https://app.finmoneymicro.com/backend/api',
      //   'https://app.zascofinance.com/backend/api',
      //   'https://youfirst.microfinancesoftware.in/backend/api',
      //   'https://kvav.microfinancesoftware.in/backend/api',
      //   'https://helpgroup.microfinancesoftware.in/backend/api',
      //   'https://simanchal.microfinancesoftware.in/backend/api',
      //   'https://raghunandan.microfinancesoftware.in/backend/api',
      //   'https://jsavior.microfinancesoftware.in/backend/api',
      //   'https://siddhi.microfinancesoftware.in/backend/api',
      //   'https://app.supergoldmicro.com/backend/api',
      //   'https://app.worthrichmicrofinance.com/backend/api',
      //   'https://raunak.microfinancesoftware.in/backend/api',
      //   'https://ruds.microfinancesoftware.in/backend/api',
      //   'https://ekam.microfinancesoftware.in/backend/api',
      //   'https://laxminivas.microfinancesoftware.in/backend/api',
      //   'https://manaina.microfinancesoftware.in/backend/api',
      //   'https://dhanvarsha.microfinancesoftware.in/backend/api',
      //   'https://pblmilap.microfinancesoftware.in/backend/api',
      //   'https://udyog.microfinancesoftware.in/backend/api',
      //   'https://twink.microfinancesoftware.in/backend/api',
      //   'https://ommsai.microfinancesoftware.in/backend/api',
      //   'https://auc.microfinancesoftware.in/backend/api',
      //   'https://laxmi.microfinancesoftware.in/backend/api',
      //   'https://tripursundari.microfinancesoftware.in/backend/api',
      //   'https://shreenidhi.microfinancesoftware.in/backend/api',
      //   'https://mtfs.microfinancesoftware.in/backend/api',
      //   'https://lm.microfinancesoftware.in/backend/api',
      //   'https://rkseva.microfinancesoftware.in/backend/api',
      //   'https://nsg.microfinancesoftware.in/backend/api',
      //   'https://dhanush.microfinancesoftware.in/backend/api',
      //   'https://a1secure.microfinancesoftware.in/backend/api',
      //   'https://growth.microfinancesoftware.in/backend/api',
      //   'https://shrimangal.microfinancesoftware.in/backend/api',
      //   'https://shrisai.microfinancesoftware.in/backend/api',
      //   'https://savera.microfinancesoftware.in/backend/api',
      //   'https://arshgroups.microfinancesoftware.in/backend/api',
      //   'https://benstar.microfinancesoftware.in/backend/api',
      //   'https://hooda.microfinancesoftware.in/backend/api',
      //   'https://jcramg.microfinancesoftware.in/backend/api',
      //   'https://gramin.microfinancesoftware.in/backend/api',
      //   'https://multiple.microfinancesoftware.in/backend/api',
      //   'https://khushpratap.microfinancesoftware.in/backend/api',
      //   'https://goldway.microfinancesoftware.in/backend/api',
      //   'https://klomshy.microfinancesoftware.in/backend/api',
      //   'https://pankajsairam.microfinancesoftware.in/backend/api',
      //   'https://arihant.microfinancesoftware.in/backend/api',
      //   'https://sitara.microfinancesoftware.in/backend/api',
      //   'https://shreeganesh.microfinancesoftware.in/backend/api',
      //   'https://shreya.microfinancesoftware.in/backend/api',
      //   'https://diamond.microfinancesoftware.in/backend/api',
      //   'https://magicgallery.microfinancesoftware.in/backend/api',
      //   'https://mauli.microfinancesoftware.in/backend/api',
      //   'https://rsr.microfinancesoftware.in/backend/api',
      //   'https://tridev.microfinancesoftware.in/backend/api',
      //   'https://supergsg.microfinancesoftware.in/backend/api',
      //   'https://khushi.microfinancesoftware.in/backend/api',
      //   'https://mks.microfinancesoftware.in/backend/api',
      //   'https://hst.microfinancesoftware.in/backend/api',
      //   'https://darshika.microfinancesoftware.in/backend/api',
      //   'https://virat.microfinancesoftware.in/backend/api',
      //   'https://rockmount.microfinancesoftware.in/backend/api',
      //   'https://supervision.microfinancesoftware.in/backend/api',
      //   'https://ghoomar.microfinancesoftware.in/backend/api',
      //   'https://mitrsewa.microfinancesoftware.in/backend/api',
      //   'https://jeevika.microfinancesoftware.in/backend/api',
      //   'https://star.microfinancesoftware.in/backend/api',
      //   'https://goldindia.microfinancesoftware.in/backend/api',
      //   'https://quickpahal.microfinancesoftware.in/backend/api',
      //   'https://finbase.microfinancesoftware.in/backend/api'
      // ],
      logo: null,
      favicon: null,
      getRecord: {},
      sessions: [],
      session: {},
      states: {},
      memberloanplans: [],
      form: new Form({
        id: '',
        name: '',
        url: '',
        companyName: '',
        shortName: '',
        upiId: '',
        upiQrCode: '',
        cibilMemberCode: '',
        cibilMemberShortName: '',
        about: '',
        cin: '',
        pan: '',
        tan: '',
        gstin: '',
        currentSession: '',
        enableMandatoryCustomerKyc: '',
        enableSMS: '',
        createCustomerSMS: '',
        autoApproveMemberCollection: '',
        showAllMembers: '',
        loanDisbursementSMS: '',
        passwordResetSMS: '',
        croneDueReminderSMS: '',
        emiCollectionSMS: '',
        documentVerificationSMS: '',
        customerCredentionSMS: '',
        memberVerifyOTPSMS: '',
        guarantorVerifyOTPSMS: '',
        staffVerifyOTPSMS: '',
        staffCredentionSMS: '',
        sattlementSMS: '',
        companyCategory: '',
        companyClass: '',
        emiReminderSendSMSDayBefore: '',
        authrizedCapital: '',
        paid_upCapital: '',
        shareNominalValue: '',
        stateOfRegistration: '',
        incorporationDate: '',
        address: '',
        city: '',
        country: '',
        email: '',
        mobile: '',
        phone: '',
        landline: '',
        fax: '',
        pin: '',
        state: '',
        logo: '',
        favicon: '',
        website: '',
        formalName: null,
        financialYearBeginFrom: null,
        currencySymbol: null,
        decimalPlaces: null,
        decimalPlacesForAmtInWords: null,
        wordRepresentingAmtAfterDecimal: null,
        lastDailyCronDate: '',
        lastInterestOnlyCronDate: ''
      })
    }
  },

  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    currentDate () {
      const date = new Date()
      // let day = date.getDate()
      // let month = date.getMonth() + 1
      // let year = date.getFullYear()

      // This arrangement can be altered based on how we want the date's format to appear.
      // let currentDate = `${year}-${month}-${day}`
      return date.getTime()
    },
    uploadImage (event) {
      const URL = 'logo'
      let data = new FormData()
      // data.append('name', 'my-picture')
      data.append('logo', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.logo = this.$store.state.imageBaseUrl + 'logo/' + response.data.logo.image_name
          // console.log('image upload response > ', response)
        }
      )
    },
    uploadFavicon (event) {
      const URL = 'favicon'
      let data = new FormData()
      // data.append('name', 'my-picture')
      data.append('favicon', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.favicon = this.$store.state.imageBaseUrl + 'favicon/' + response.data.favicon.image_name
          // console.log('image upload response ', response)
        }
      )
    },
    selectSession () {
      this.form.currentSession = this.session.id
    },
    editProfile () {
      $('#modal-xl').modal({backdrop: 'static', keyboard: false})
      this.form.fill(this.getRecord)
      this.session = this.getRecord.financial_session
      this.session.name = this.getRecord.financial_session.session
    },
    loadState () {
      this.$axios
        .get('state?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.states = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getProfilePhoto () {
      // let photoLength = (this.form.photo.length > 191) ? this.form.photo : "img/profile/" + this.form.photo;
    },
    checkLogo (e) {
      let file = e.target.files[0]
      // console.log(file);
      let reader = new FileReader()
      if (file['size'] < 1048576) {
        reader.onloadend = (e) => {
          this.form.logo = reader.result
        }
        reader.readAsDataURL(file)
      } else {
        Swal.fire(
        'Failed!',
        'This file Size more than 1MB.',
        'error'
        )
      }
    },
    updatelogo () {
      this.form.put('api/profile')
      .then(() => {
        Toast.fire({
          icon: 'success',
          title: 'User Profile Updated Successfully'
        })
      })
      .catch(() => {
        Toast.fire({
          icon: 'error',
          title: 'Please Try Again'
        })
      })
    },
    updateProfile () {
      /* Swal.fire({title: 'Are you sure?', text: "You won't be able to revert this!", icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, confirm it!'}).then((result) => {
        if (result.isConfirmed) {
          Swal.fire('Success!', 'Successfully.', 'success')
        }
      }) */
      Swal.fire({title: 'Are you sure?', text: "You won't be able to revert this!", icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, confirm it!'}).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .put('settings/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')
              $('#modal-xl').modal('hide')
              Toast.fire({
                icon: 'success',
                title: 'Profile Details Updated Successfully'
              })
            })
            .catch(
              function (error) {
                Toast.fire({ icon: 'error', title: 'Please Try Again' })
                this.form.errors.errors = error.response.data.error
              }.bind(this)
            )
          Swal.fire('Success!', 'Successfully.', 'success')
        }
      })
    },
    testFun () {
      this.$axios
        .get('test', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          console.log('data')
          console.log(data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    testButton () {
      // this.$axios
      //   .get('profitloss', {
      //     headers: { Authorization: 'Bearer ' + localStorage.token }
      //   })
      //   .then((response) => response.data)
      //   .then((data) => {
      //     loader.hide()
      //     console.log(data)
      //   })
      //   .catch(function (error) {
      //     console.log(error)
      //   })
      this.$axios
        .post('memberemiresattlement', { 'member_loan_plan_id': this.memberloanplan.id }, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          Swal.fire('Re-Settled!', 'Your Record has been Re-Settled.', 'success')
          Fire.$emit('AfterCreate')
        }).catch(function (error) { console.log(error) })
    },
    dailyCronButton (date) {
      this.$axios
        .get('manualcron/daily?date=' + date, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          console.log(data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadSessionData () {
      this.sessions = []
      this.session = {}
      let loader = this.$loading.show()
      this.$axios
        .get('session?all=all', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.sessions = data.data
          _.forEach(this.sessions, function (item, key) {
            this.sessions[key].name = item.session
          }.bind(this))
        })
        .catch(function (error) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error
          })
        })
    },
    loadData () {
      let loader = this.$loading.show()
      // var pageUrl = 'memberloanplan?status=processing&all=all'
      // this.$axios
      //   .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
      //   .then((data) => {
      //     console.log(data)
      //     this.memberloanplans = data.data
      //     _.forEach(this.memberloanplans, function (item, key) {
      //       alert('test')
      //       this.$axios
      //         .post('memberemiresattlement', { 'member_loan_plan_id': item.id }, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
      //         .then((data) => {
      //           console.log('success')
      //         })
      //     }.bind(this))
      //   }).catch(function (error) { console.log(error) })
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.$store.commit('setSettingRecords', data)
          this.getRecord = data
          if (this.getRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getRecord.logo
            if (this.getRecord.favicon != null) {
              this.favicon = this.$store.state.imageBaseUrl + 'favicon/' + this.getRecord.favicon
            }
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },

  created () {
    this.loadSessionData()
    this.loadData()
    this.loadState()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
    this.testFun()
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>



// WEBPACK FOOTER //
// Profile.vue?6e36748f